import { MLM, MsTracking, NOT_SET, TrackingParameter, createTealiumTracking } from '@sunrise/tracking'

import { DecoratedEstate } from '../../ts/mapper/decoratedItemEstate.interface'
import { ActionIds, MLMData } from '../../ts/tracking/mlmActionIds.enum'
import { staticMlmTrackingData } from '../../ts/tracking/mlmStaticTrackingData'
import { TealiumTrackingIds } from '../../ts/tracking/tealiumTrackingIds.enum'
import { getCompanyName, getPositionAsString, getTypePaid, getVariant } from '../../ts/utils/trackingUtils'

import { ComponentName } from './MsResultListItem.enum'

export function buildTealiumTrackingData(
    item: DecoratedEstate,
    parentComponent: ComponentName,
    isExposeeOnline: boolean,
): MsTracking {
    return createTealiumTracking({
        ...getTealiumTrackingData(parentComponent, isExposeeOnline, item.ownInventory),
        mslayer_element_company_name: getCompanyName(item.ownInventory),
        mslayer_element_id: item.exposeeId,
        mslayer_element_position: getPositionAsString(item.position),
        mslayer_element_text: item.title,
        mslayer_element_variant: getVariant(item.newestEstate),
        mslayer_element_detail_start_date: item.createdDateFormatted,
    })
}

function getTealiumTrackingData(
    parentComponent: ComponentName,
    isExposeeOnline: boolean,
    isOwnInventory: boolean,
): TrackingParameter {
    return {
        mslayer_element_data_id: getDataId(parentComponent, isExposeeOnline, isOwnInventory),
        mslayer_element_type_text: NOT_SET,
        mslayer_element_count: NOT_SET,
        mslayer_element_body_type: 'list',
        mslayer_affiliate_id: NOT_SET,
    }
}

export function buildMlmTrackingData(
    item: DecoratedEstate,
    currentUrl: string,
    parentComponent: ComponentName,
    isExposeeOnline: boolean,
): MLM.TrackingData {
    return {
        ...staticMlmTrackingData,
        page: MLMData.DEFAULT_PAGE as number,
        actionId: getActionId(parentComponent, isExposeeOnline, item.ownInventory),
        componentId: parentComponent,
        pageUrl: currentUrl,
        items: [buildMlmItems(item)],
    }
}

function buildMlmItems(item: DecoratedEstate): MLM.Item {
    return {
        id: item.exposeeId,
        type: getCompanyName(item.ownInventory),
        typePaid: getTypePaid(item.ownInventory),
        typePosition: item.position,
    }
}

function getDataId(parentComponent: ComponentName, isExposeeOnline: boolean, isOwnInventory: boolean): string {
    if (!isExposeeOnline && isOwnInventory) {
        return TealiumTrackingIds.RESULT_LIST_RECOMMENDER_CLICK_OFFLINE
    }

    switch (parentComponent) {
        case ComponentName.WRAPPER:
        case ComponentName.RESULTLIST:
            return TealiumTrackingIds.RESULT_LIST_WRAPPER_CLICK
        case ComponentName.RECOMMENDER:
            return TealiumTrackingIds.RESULT_LIST_RECOMMENDER_CLICK_ONLINE
    }
}

function getActionId(parentComponent: ComponentName, isExposeeOnline: boolean, isOwnInventory: boolean) {
    if (!isExposeeOnline && isOwnInventory) {
        return ActionIds.RECOMMENDER_CLICK_OFFLINE
    }

    switch (parentComponent) {
        case ComponentName.WRAPPER:
        case ComponentName.RESULTLIST:
            return ActionIds.GENERAL_CLICK
        case ComponentName.RECOMMENDER:
            return ActionIds.RECOMMENDER_CLICK_ONLINE
    }
}
